import { render } from "./ReservationTable.vue?vue&type=template&id=8aed8ab4"
import script from "./ReservationTable.vue?vue&type=script&lang=js"
export * from "./ReservationTable.vue?vue&type=script&lang=js"

import "./ReservationTable.vue?vue&type=style&index=0&id=8aed8ab4&lang=scss"

import exportComponent from "/Users/niteshdas/Projects/wordpress/wp-content/plugins/easy-restaurant-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__